import { store } from 'redux/store';
import { getPartnerUsufructData } from 'modules/partners/api/getPartnerUsufructData';
import { Partner, UsufructData } from 'types';

export const getUsufructData = async (partners: Partner[]) => {
  const results = await Promise.all(
    partners.map(async (partner) => {
      const partnerId = partner._id;

      // Dispatch action and return both id and result
      const usufructData = await store.dispatch(
        getPartnerUsufructData(partnerId)
      );

      return usufructData ? { partnerId, usufructData } : null;
    })
  );

  const usufructDataByPartner: { [key: string]: UsufructData[] } = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const result of results) {
    if (result) {
      usufructDataByPartner[result.partnerId] = result.usufructData;
    }
  }

  return usufructDataByPartner;
};
